import * as React from 'react';

import { fireNewRelicErrorEvent } from '@origin-digital/reporting-client';
import { Card, CardStackSection } from '@origin-digital/ods-core';
import { ErrorMessage } from '@origin-digital/messages';

import { errorTracking } from 'src/utils/tracking';

import * as content from './content.json';

interface IState {
  error?: Error;
}

export class ErrorWrapper extends React.PureComponent<{}, IState> {
  public state: IState = {};

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      fireNewRelicErrorEvent(error);
      errorTracking(error);

      return (
        <CardStackSection data-id="payment-error">
          <Card>
            <ErrorMessage heading={content.heading} text={content.text} markdown />
          </Card>
        </CardStackSection>
      );
    }

    return children;
  }
}
